
import Vue from 'vue'
import { formatDateTime } from '@/utils/dates'

export default Vue.extend({
  name: 'HistoryToolTip',
  props: {
    content: Object,
    createString: { type: String, default: 'info.created_datetime' },
    updateString: { type: String, default: 'info.updated_datetime' },
  },

  methods: {
    formatDateTime,
  },
})
